<template>
	<section class="block quote">

        <blockquote v-html="$getField('quote_text', data)" :style="{ color: $getField('quote_text_colour', data) }">
        </blockquote>

        <p class="cite" :style="{ color: $getField('quote_cite_colour', data) }">{{ $getField('quote_cite', data) }}</p>

    </section>
</template>

<script>
export default {
  props: {
    data: [Array, Object]
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Projects/Rows/Quote.vue